// extracted by mini-css-extract-plugin
export default {"deckName":"deckName_deckName__ml0Dm","scrollBackgroundPosY":"deckName_scrollBackgroundPosY__MJlAI","scrollPosX":"deckName_scrollPosX__sq0jb"};